"use client";

import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { AppConfig } from "@/lib/app-config";

const AppConfigContext = createContext<AppConfig>({
  appEnv: "development",
  appDomain: "localhost:3000",
  appUrl: "http://localhost:3000",
  adminUrl: "https://admin.skrift.ai",
  posthogEnabled: false,
  posthogProjectToken: "",
  posthogHost: "https://us.i.posthog.com",
});

export function AppConfigProvider({
  config,
  children,
}: {
  config: AppConfig;
  children: ReactNode;
}) {
  return (
    <AppConfigContext.Provider value={config}>
      {children}
    </AppConfigContext.Provider>
  );
}

export function useAppConfig(): AppConfig {
  return useContext(AppConfigContext);
}
